module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"section":{"prefix":"その他の","title":"{prefix}企業実習"}}}')
  delete Component.options._Ctor
}
